export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6875.78e7fdd9.jpg";